const t = "top", o = "right", O = "bottom", T = "left", c = {
  [t]: t,
  [o]: o,
  [O]: O,
  [T]: T
}, n = {
  [T]: T,
  [o]: o
}, s = {
  [t]: t,
  [O]: O
};
export {
  c as POSITION,
  n as X_POSITION,
  s as Y_POSITION
};
//# sourceMappingURL=position.es.js.map
